import Vue from 'vue'
import * as types from './mutation-types'
import { requestUtils, formDataFactory } from '../../helpers'

const state = {
  user: {}
}

const getters = {
  getUser (state) {
    return state.user
  },
  getLoggedIn (state) {
    return !!state.user.id
  }
}

const actions = {
  createAccount ({ commit, rootGetters }, data) {
    let formData = formDataFactory.build(data, 'user', 'form-data')
    return requestUtils.post('/users', formData)
      .then((response) => {
        if (response.success) {
          Vue.cookie.set('token', response.data.token)
          commit(types.LOGIN_USER, response.data)
        }
        return response
      })
  },
  auth ({ commit, rootGetters }, data) {
    let formData = formDataFactory.build(data, 'user', 'form-data')
    return requestUtils.post('/users/sign_in', formData)
      .then((response) => {
        if (response.success) {
          Vue.cookie.set('token', response.data.token)
          commit(types.LOGIN_USER, response.data)
        }
        return response
      })
  },
  checkLogin ({ commit }) {
    let token = Vue.cookie.get('token')
    if (token) {
      let formData = formDataFactory.build({ token }, null, 'form-data')
      return requestUtils.post('/users/check_token', formData)
        .then((response) => {
          if (response.success) {
            commit(types.LOGIN_USER, response.data)
          }
          return response
        })
    } else {
      return Promise.reject(new Error('Blank token'))
    }
  },
  logout ({ commit }) {
    Vue.cookie.delete('token')
    commit(types.LOGOUT_USER)
  }
}

const mutations = {
  [types.LOGIN_USER] (state, user) {
    state.user = user
  },
  [types.LOGOUT_USER] (state) {
    state.user = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js